jQuery(($) => {
 
    if ($('.m-private-services-menu')[0]) {

    }
});
